import { PublicTenant } from '@rewardops/env'

export const isAirCanada = (tenant: PublicTenant) => {
  return tenant?.flags?.customLogic?.includes('ac')
}
